import { TDashboardSlotItem } from "@/data/types";

export interface DashboardSlotsState {
  items: TDashboardSlotItem[];
  currentDashboardSlot: TDashboardSlotItem | null;
}

export const DefaultDashboardSlotsState: DashboardSlotsState = {
  items: [],
  currentDashboardSlot: null,
};